import marketplace from 'cfg/marketplace.json';

const { checkout: { checkoutUrl } } = marketplace;

export const CART_STEP = -10;
export const TBD_STEP = 1;

export const NEW_ADDRESS_STEP = 10;
export const SAVED_ADDRESS_STEP = 12;
export const EDIT_ADDRESS_STEP = 15;
export const ADDRESS_STEP = 16;

export const NEW_PAYMENT_STEP = 20;
export const PAYMENT_STEP = 22;

export const EDIT_BILLING_ADDRESS_STEP = 26;
export const NEW_BILLING_ADDRESS_STEP = 27;
export const SELECT_BILLING_ADDRESS_STEP = 29;

export const SHIP_OPTIONS_STEP = 30;
export const GIFT_OPTIONS_STEP = 35;
// caap uses a route for updating the quntity, we'll need to at least have
// a similar route to make sure no one cutting over mid checkout has an issues
// https://github01.zappos.net/mweb/marty/issues/2754
// export const UPDATE_QUANTITY = 40;
export const REVIEW_STEP = 50;
export const UNKNOWN_STEP = 100;

export const CHECKOUT_PAGE_MAP = {
  [ADDRESS_STEP]: 'address',
  [REVIEW_STEP]: 'spc',
  [PAYMENT_STEP]: 'pay'
};

export const CHECKOUT_URL_MAP = {
  [checkoutUrl]: TBD_STEP,
  [`${checkoutUrl}/initiate`]: TBD_STEP,
  [`${checkoutUrl}/address`]: ADDRESS_STEP,
  [`${checkoutUrl}/address/new`]: NEW_ADDRESS_STEP,
  [`${checkoutUrl}/address/edit`]: EDIT_ADDRESS_STEP,
  [`${checkoutUrl}/billing`]: SELECT_BILLING_ADDRESS_STEP,
  [`${checkoutUrl}/billing/edit`]: EDIT_BILLING_ADDRESS_STEP,
  [`${checkoutUrl}/billing/new`]: NEW_BILLING_ADDRESS_STEP,
  [`${checkoutUrl}/pay`]: PAYMENT_STEP,
  [`${checkoutUrl}/pay/new`]: NEW_PAYMENT_STEP,
  [`${checkoutUrl}/shipoption`]: SHIP_OPTIONS_STEP,
  [`${checkoutUrl}/giftoptions`]: GIFT_OPTIONS_STEP,
  [`${checkoutUrl}/spc`]: REVIEW_STEP
};

export const CHECKOUT_STEP_MAP = {
  [TBD_STEP]: checkoutUrl,
  [ADDRESS_STEP]: `${checkoutUrl}/address`,
  [NEW_ADDRESS_STEP]: `${checkoutUrl}/address/new`,
  [EDIT_ADDRESS_STEP]: `${checkoutUrl}/address/edit`,
  [PAYMENT_STEP]: `${checkoutUrl}/pay`,
  [NEW_PAYMENT_STEP]: `${checkoutUrl}/pay/new`,
  [REVIEW_STEP]: `${checkoutUrl}/spc`,
  [SHIP_OPTIONS_STEP]: `${checkoutUrl}/shipoption`,
  [GIFT_OPTIONS_STEP]: `${checkoutUrl}/giftoptions`,
  [EDIT_BILLING_ADDRESS_STEP]: `${checkoutUrl}/billing/edit`,
  [NEW_BILLING_ADDRESS_STEP]: `${checkoutUrl}/billing/new`,
  [SELECT_BILLING_ADDRESS_STEP]: `${checkoutUrl}/billing`
};
